import { call, delay, put, race, select, take } from 'redux-saga/effects';

import requests from '../requests';
import selectors from '../../../selectors';
import actions from '../../../actions';
import EntryActionTypes from '../../../constants/EntryActionTypes';
import { socket } from '../../../api';

// Ignore brief socket drops (VPN toggle, Wi‑Fi handoff) before showing the banner.
const DISCONNECT_BANNER_DELAY_MS = 3000;

export function* handleSocketDisconnect() {
  const { reconnect } = yield race({
    timeout: delay(DISCONNECT_BANNER_DELAY_MS),
    reconnect: take(EntryActionTypes.SOCKET_RECONNECT_HANDLE),
  });

  if (!reconnect && !socket.connected) {
    yield put(actions.handleSocketDisconnect());
  }
}

export function* handleSocketReconnect() {
  const currentUserId = yield select(selectors.selectCurrentUserId);
  const { boardId } = yield select(selectors.selectPath);

  yield put(actions.handleSocketReconnect.fetchCore(currentUserId, boardId));

  const {
    user,
    board,
    users,
    projects,
    projectManagers,
    boards,
    boardMemberships,
    labels,
    lists,
    cards,
    cardMemberships,
    cardLabels,
    tasks,
    attachments,
    activities,
    notifications,
    pointSystems,
  } = yield call(requests.fetchCore); // TODO: handle error

  yield put(
    actions.handleSocketReconnect(
      user,
      board,
      users,
      projects,
      projectManagers,
      boards,
      boardMemberships,
      labels,
      lists,
      cards,
      cardMemberships,
      cardLabels,
      tasks,
      attachments,
      activities,
      notifications,
      pointSystems,
    ),
  );
}

export default {
  handleSocketDisconnect,
  handleSocketReconnect,
};
